import localforage from "localforage";

export const idb = localforage.createInstance({
  name: "covid-mobi-idb",
  driver: localforage.INDEXEDDB,
  storeName: `covid-mobi-store`
});
